module.exports = __webpack_public_path__ + "img/inbox-receives.ce4ab848.webp";